// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import StarFull from '../_raw/ui/icon_star_full.svg';
import withIconProps from '../withIconProps';

export default withIconProps(StarFull);
